import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './dropdown.magic.css.js';
import script from './dropdown.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown",class:[{
        'dropdown--ellipsis': _vm.ellipsis,
        'dropdown--small': _vm.small,
        'has-icon-prefix': !!_vm.iconPrefix,
        'has-value': _vm.hasValue,
    }],attrs:{"data-v-test-id":"dropdown","part":_vm.$p('dropdown', [{
        'dropdown--ellipsis': _vm.ellipsis,
        'dropdown--small': _vm.small,
        'has-icon-prefix': !!_vm.iconPrefix,
        'has-value': _vm.hasValue,
    }]),"data-option":_vm.currentOption}},[(!!_vm.iconPrefix)?_c('magic-ui-icon',{staticClass:"icon icon--prefix",attrs:{"part":"icon icon--prefix","name":_vm.iconPrefix}}):_vm._e(),_vm._v(" "),_c('select',{staticClass:"select",class:[{
            'select--light': _vm.light,
            'select--link': _vm.link,
            'is-disabled': _vm.disabled,
            'has-value': _vm.hasValue,
        }],attrs:{"part":_vm.$p('select', [{
            'select--light': _vm.light,
            'select--link': _vm.link,
            'is-disabled': _vm.disabled,
            'has-value': _vm.hasValue,
        }]),"disabled":_vm.disabled},on:{"focus":function($event){return _vm.setFocused(true)},"blur":function($event){return _vm.setFocused(false)},"change":function($event){$event.stopPropagation();return _vm.changed($event.target)}}},[(_vm.hasEmptyPlaceholder || _vm.placeholderLabel)?_c('option',{staticClass:"option",attrs:{"selected":"","value":"","part":"option","disabled":!_vm.allowEmpty},domProps:{"innerHTML":_vm._s(_vm.placeholderLabel)}}):_vm._e(),_vm._v(" "),_vm._l((_vm.options),function(ref,index){
        var val = ref.value;
        var name = ref.name;
return _c('option',{key:(name + "." + index),staticClass:"option",attrs:{"part":"option"},domProps:{"value":index,"selected":_vm.value !== null && val === _vm.value}},[_vm._v("\n            "+_vm._s(name)+"\n        ")])})],2),_vm._v(" "),_c('magic-ui-icon',{staticClass:"icon",attrs:{"part":"icon","name":_vm.isFocused ? 'up-arrow' : 'down-arrow'}})],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-dfaa330e_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-dfaa330e";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
